import { createExperimentEventStore } from "./firestoreEventStore";
import { isLocalExperimentMode } from "./localMode";

const experimentEventStore = createExperimentEventStore({
  collectionName: "experimentEvents",
  storageKey: "experimentEvents:v1",
  maxOnceEntries: 3000,
  isDisabled: isLocalExperimentMode,
});

export const trackExperimentEvent = experimentEventStore.trackEvent;
export const trackExperimentEventOnce = experimentEventStore.trackOnce;
export const flushCriticalExperimentEvents =
  experimentEventStore.flushCriticalOutbox;
